module.exports = "/packs/images/svg/facilities/racquet_sports~870c39a23d21320489d0efb81fa83c15.svg";